import React from 'react';

// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => {
  /*return <ModalProvider>{element}</ModalProvider>;*/
};
